/* eslint-disable no-underscore-dangle */
// This file is responsible for defining settings that are set during built time but which are required in both
// the server and client.
//
// This works by defining the client side variables in src/frontend/react-app/src/client/scripts/env.script.ts which
// enables them to be available on the client, and by using process.env for server side lookups.
//
export interface RoverSettings {
  ROVER_ENVIRONMENT: string;
  GOOGLE_MAPS_API_KEY: string;
  AMPLITUDE_API_KEY: string;
}

const getRoverSettings = (): RoverSettings => {
  if (process.env.JS_ENV_CLIENT) {
    return {
      ROVER_ENVIRONMENT: window.__ROVER__ENV__?.ROVER_ENVIRONMENT || '',
      GOOGLE_MAPS_API_KEY: window.__ROVER__ENV__?.GOOGLE_MAPS_API_KEY || '',
      AMPLITUDE_API_KEY: window.__ROVER__ENV__?.AMPLITUDE_API_KEY || '',
    };
  }

  if (process.env.JS_ENV_SERVER) {
    return {
      ROVER_ENVIRONMENT: process.env.ROVER_ENVIRONMENT || '',
      GOOGLE_MAPS_API_KEY: process.env.GOOGLE_MAPS_API_KEY || '',
      AMPLITUDE_API_KEY: process.env.AMPLITUDE_API_KEY || '',
    };
  }

  return { ROVER_ENVIRONMENT: '', GOOGLE_MAPS_API_KEY: '', AMPLITUDE_API_KEY: '' };
};

const roverSettings = getRoverSettings();
export default roverSettings;
